@if (question && question.questionReplyInputType === replyType.Checkbox) {
	<div class="question" [ngClass]="{ 'answered': isAnswered, 'loading': loading, 'editable': editable }">
		@for (replyView of replyGroups; track replyView.index) {
			@for (_ of [].constructor(question.requiredNumberOfReplies); track _; let i = $index) {
				<custom-input [(value)]="replyView.checkBoxReplies[i]" (valueChange)="updateCheckbox(replyView, i, $event)" [inputType]="inputType" [label]="question.questionText" />
			}
		}
	</div>
}
@else if (question) {
	@if (displayAsForm && editable) {
		<h3>{{ question.questionText }}</h3>
		@for (replyView of replyGroups; track replyView.index) {
			<questionnaire-input (onUpdate)="refreshAnsweredState()" [data]="{ replyView: replyView, type: question.questionReplyInputType, displayIndex: replyGroups.length > 1 ? '#'+replyView.index : undefined, inputType: inputType, numberOfReplies: question.requiredNumberOfReplies, selectList: selectList }" />
		}
	}
	@else {
		<div editable-content *editableData="let edit from replyGroups" [editEnabled]="editable && !loading" (valueChanged)="updateReplies($event)">
			<div class="question" [ngClass]="{ 'answered': isAnswered, 'rejected': isRejected, 'loading': loading, 'editable': editable }">
				<data-table>
					<data-row>
						<display-content class="row">
							<data-row>
								<label class="text-block">{{ question.questionText }}</label>
								@for (replyView of replyGroups; track replyView.index) {
									<div>
										@if (replyGroups.length > 1) {
											<span class="group-index">#{{ replyView.index }}:</span>
										}
										<div class="reply-group">
											@for (_ of [].constructor(question.requiredNumberOfReplies); track _; let i = $index) {
												<questionnaire-reply [reply]="replyView.replies[i]"
																	 [replyType]="question.questionReplyInputType" />
											}
										</div>
									</div>
								}
							</data-row>
						</display-content>
						<edit-content class="row">
							<data-row>
								<label class="text-block">{{ question.questionText }}</label>
								@for (replyView of edit.value; track replyView.index) {
									<questionnaire-input [data]="{ replyView: replyView, type: question.questionReplyInputType, displayIndex: edit.value.length > 1 ? '#'+replyView.index : undefined, inputType: inputType, numberOfReplies: question.requiredNumberOfReplies, selectList: selectList }" />
								}
							</data-row>
						</edit-content>
					</data-row>
				</data-table>
			</div>
		</div>
	}
}
